import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Notifications from './Notifications/notifications';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper
    }
}));

export default function NotificationTabs(props) {
    const {t} = useTranslation();
    const classes = useStyles();
    const [value, setValue] = useState(1);

    function handleChange(event, newValue) {
        setValue(newValue);
    }

    return (
        <div className={classes.root}>
            <AppBar position="static" style={{backgroundImage: 'linear-gradient(to right, #E98368, #CD5A82)'}}>
                <Tabs value={value} onChange={handleChange}>
                    {/* <Tab label={t('CONTENT.NOTIFICATION.LOGS')} /> */}
                    <Tab label={t('CONTENT.NOTIFICATION.NOTIFICATIONS')}/>
                    {/* <Tab label={t('CONTENT.NOTIFICATION.SETTINGS')} /> */}
                    <IconButton onClick={props.toggleDrawer('right', false)}>
                        <CloseIcon/>
                    </IconButton>
                </Tabs>
            </AppBar>
            <div style={{paddingTop: 10}}>
                {
                    value === 0 ? "Logs" :
                        value === 1 ? <Notifications/> :
                            value === 2 ? "Settings" : null
                }
            </div>
        </div>
    );
}
